export default __webpack_public_path__ + "static/media/noto-sans-cjk-sc.6a76a23a.png";